import React from 'react';
import { DefaultCTAModal } from './default';
import { DisonaCTAModal } from './disona';
import { appConfig } from '../../../config';
import { DISONA_PARTNER } from '../../../common/constants/trading.constants';

export const CTAModal = (props) => {
  switch (appConfig.whiteLabelPartner) {
    case DISONA_PARTNER:
      return <DisonaCTAModal {...props} />;
    default:
      return <DefaultCTAModal {...props} />;
  }
};
